export const clusterStyles = [
  {
    width: 35,
    height: 50,
    textSize: 8,
    textColor: '#fff',
    url: '/svg/poi-clusterer.svg',
  },
  {
    width: 35,
    height: 50,
    textSize: 8,
    textColor: '#fff',
    url: '/svg/poi-clusterer.svg',
  },
  {
    width: 35,
    height: 50,
    textSize: 8,
    textColor: '#fff',
    url: '/svg/poi-clusterer.svg',
  },
];
